import axios from "axios";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

const GRAPH_BACKEND_URL = `${EnvironmentConfig.gatewayURL}/service/graph`;

export type AddDeviceToGroupResponse = {
    success: boolean;
    message?: string;
    error?: string;
};

export const addDeviceToEntraGroup = async (
    deviceName: string,
    groupName: string,
    tokenFn?: JwtTokenFn
): Promise<AddDeviceToGroupResponse> => {
    try {
        if (!deviceName) {
            return {
                success: false,
                error: "deviceName is required",
            };
        }

        const headers = tokenFn
            ? { Authorization: `Bearer ${await tokenFn()}` }
            : undefined;

        const response = await axios.post(`${GRAPH_BACKEND_URL}/add-device-to-group`, {
            deviceName,
            groupName,
        }, { headers });

        return {
            success: response.data.success,
            message: response.data.message,
            error: response.data.error
        };
    } catch (error) {
        console.error("Error adding device to group:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Unknown error occurred",
        };
    }
};